import { useEffect, useState } from 'react'

/**
 * The time now, moving on once a minute — for relative times like "12 min
 * ago". Never faster: a time that ticks every second pulls the eye and says
 * nothing (docs/LIVE-DATA.md §3).
 */
export function useMinute(): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 60_000)
    return () => window.clearInterval(timer)
  }, [])
  return now
}
